module.exports = __webpack_public_path__ + "img/steve_anna.98c06b1e.svg";